import React, { useEffect, useState, useContext } from "react";
import MainTitle from "components/MainTitle";
import { Button, Heading, Text } from "mondrian-react";
import GenericModal from "components/GenericModal";
import { getOrigin } from "core/Utils/Origin";

import ShortcutListLinks from "../../components/ShortcutListLinks";
import LinksConfig from "../../components/ShortcutListLinks/ShortcutConfig";
import LinksConfigContrast from "../../components/ShortcutListLinks/ShortcutConfigContraste";
import { store } from "store.js";

const Success = (props) => {
  const { setForm, formData, navigation, title, content, children, firstTab } =
    props;
  const [showModal, setShowModal] = useState(false);
  const [originCallback, setOriginCallback] = useState(null);
  const globalState = useContext(store);
  const { state } = globalState;
  const { contrast } = state;

  useEffect(function () {
    const origin = window.sessionStorage.getItem("origin");
    if (origin) {
      setShowModal(true);
      setOriginCallback(getOrigin(origin));
    }
  }, []);

  function handleReturn() {
    if (originCallback) {
      window.location = originCallback;
      window.sessionStorage.removeItem("origin")
    }
  }

  return (
    <>
      <div>
        <MainTitle sm>{title}</MainTitle>
        {children}
        {contrast && (
          <ShortcutListLinks links={LinksConfig} firstTab={firstTab} />
        )}
        {!contrast && (
          <ShortcutListLinks links={LinksConfigContrast} firstTab={firstTab} />
        )}

        {showModal && (
          <GenericModal
            ariaLabel="Ação concluída com sucesso"
            showModal={showModal}
            header={<Heading md>Ação concluída com sucesso.</Heading>}
            content={
              <Text>
                Acesse o botão abaixo para retornar onde estava ou feche essa
                mensagem para continuar na área do Meu Perfil.
              </Text>
            }
            footer={
              <Button
                data-gtm-event-category="minha-claro:customer2fa"
                data-gtm-event-action="clique:botao:modal"
                data-gtm-event-label="nos-ajude-a-entender-melhor:ok-enviar"
                onClick={handleReturn}
                primary
              >
                Retornar para onde estava
              </Button>
            }
          />
        )}
      </div>
    </>
  );
};

export default Success;
